import { Box, Link as ChakraLink } from '@chakra-ui/react';
import { Alert } from '@time-line/components/common';

export interface NoReviewsAlertProps {
  handleResetFilters: () => void;
}

export function NoReviewsAlert({ handleResetFilters }: NoReviewsAlertProps) {
  return (
    <Box mb="m">
      <Alert status="error" color="red.600">
        No reviews match these filters. Showing all reviews.{' '}
        <ChakraLink
          as="button"
          type="button"
          variant="unstyled"
          textDecoration="underline"
          onClick={handleResetFilters}
        >
          Reset filters
        </ChakraLink>
      </Alert>
    </Box>
  );
}
